import { TaskStatus } from '../../../../definition'

export type FilterDataType = {
  newBooking?: boolean
  reAssigned?: boolean
  recurringBookingRequest?: boolean
  assigned?: boolean
  statuses?: TaskStatus[]
  notes?: boolean
  contractBookings?: boolean
  oneTimeBookings?: boolean
  search?: string
  reschedule?: boolean
}

type ScheduleSearchFilterComponentPropsType = {
  filterData: FilterDataType
  onChange: (changedFilter: FilterDataType) => void
}

export const ScheduleSearchFilterComponent = (props: ScheduleSearchFilterComponentPropsType) => {
  const all =
    !props.filterData.newBooking &&
    !props.filterData.reschedule &&
    !props.filterData.recurringBookingRequest &&
    !props.filterData.assigned &&
    (!props.filterData.statuses || props.filterData.statuses.length === 0) &&
    !props.filterData.notes &&
    !props.filterData.contractBookings

  const onChange = (data: FilterDataType, all?: boolean) => {
    if (all) {
      props.onChange({
        newBooking: undefined,
        reAssigned: undefined,
        recurringBookingRequest: undefined,
        assigned: undefined,
        statuses: undefined,
        notes: undefined,
        contractBookings: undefined,
        oneTimeBookings: undefined,
        reschedule: undefined
      })
    } else {
      props.onChange(data)
    }
  }

  const onChangeStatus = (status: TaskStatus) => {
    const index = props.filterData.statuses?.indexOf(status)
    if (index !== undefined && index >= 0) {
      const statuses = [...(props.filterData.statuses || [])]
      statuses.splice(index, 1)
      onChange({ ...props.filterData, statuses })
    } else {
      const statuses = [...(props.filterData.statuses || [])]
      statuses.push(status)
      onChange({ ...props.filterData, statuses })
    }
  }

  return (
    <div className='schedule-search-filter'>
      <div className='schedule-filter'>
        <div className='schedule-filter-item'>
          <label>
            <span>All</span>
            <input type='checkbox' checked={all} onChange={() => onChange(props.filterData, !all)} />
          </label>
        </div>
        <div className='schedule-filter-item' style={{ marginLeft: 8 }}>
          <label>
            <span>New Bookings</span>
            <input
              type='checkbox'
              checked={props.filterData.newBooking}
              onChange={() =>
                onChange({
                  ...props.filterData,
                  newBooking: !props.filterData.newBooking
                })
              }
            />
          </label>
        </div>
        <div className='schedule-filter-item' style={{ marginLeft: 8 }}>
          <label>
            <span>Reschedule Required</span>
            <input
              type='checkbox'
              checked={props.filterData.reschedule}
              onChange={() =>
                onChange({
                  ...props.filterData,
                  reschedule: !props.filterData.reschedule
                })
              }
            />
          </label>
        </div>
        <div className='schedule-filter-item' style={{ marginLeft: 8 }}>
          <label>
            <span>Assigned</span>
            <input
              type='checkbox'
              checked={props.filterData.assigned}
              onChange={() =>
                onChange({
                  ...props.filterData,
                  assigned: !props.filterData.assigned
                })
              }
            />
          </label>
        </div>
        <div className='schedule-filter-item' style={{ marginLeft: 8 }}>
          <label>
            <span>On The Way</span>
            <input
              type='checkbox'
              checked={props.filterData.statuses?.includes(TaskStatus.ON_THE_WAY)}
              onChange={() => onChangeStatus(TaskStatus.ON_THE_WAY)}
            />
          </label>
        </div>
        <div className='schedule-filter-item' style={{ marginLeft: 8 }}>
          <label>
            <span>Task Started</span>
            <input
              type='checkbox'
              checked={props.filterData.statuses?.includes(TaskStatus.STARTED)}
              onChange={() => onChangeStatus(TaskStatus.STARTED)}
            />
          </label>
        </div>
        <div className='schedule-filter-item' style={{ marginLeft: 8 }}>
          <label>
            <span>Finalising</span>
            <input
              type='checkbox'
              checked={props.filterData.statuses?.includes(TaskStatus.COMPLETED)}
              onChange={() => onChangeStatus(TaskStatus.COMPLETED)}
            />
          </label>
        </div>
        <div className='schedule-filter-item' style={{ marginLeft: 8 }}>
          <label>
            <span>Completed</span>
            <input
              type='checkbox'
              checked={props.filterData.statuses?.includes(TaskStatus.DONE)}
              onChange={() => onChangeStatus(TaskStatus.DONE)}
            />
          </label>
        </div>
        <div className='schedule-filter-item' style={{ marginLeft: 8 }}>
          <label>
            <span>Canceled</span>
            <input
              type='checkbox'
              checked={props.filterData.statuses?.includes(TaskStatus.CANCELED)}
              onChange={() => onChangeStatus(TaskStatus.CANCELED)}
            />
          </label>
        </div>
        <div className='schedule-filter-item' style={{ marginLeft: 8 }}>
          <label>
            <span>Contract Bookings</span>
            <input
              type='checkbox'
              checked={props.filterData.contractBookings}
              onChange={() =>
                onChange({
                  ...props.filterData,
                  contractBookings: !props.filterData.contractBookings
                })
              }
            />
          </label>
        </div>
        <div className='schedule-filter-item' style={{ marginLeft: 8 }}>
          <label>
            <span>One-Time Bookings</span>
            <input
              type='checkbox'
              checked={props.filterData.oneTimeBookings}
              onChange={() =>
                onChange({
                  ...props.filterData,
                  oneTimeBookings: !props.filterData.oneTimeBookings
                })
              }
            />
          </label>
        </div>
      </div>
    </div>
  )
}
